import { z } from 'zod'
import { baseSchema } from './base'

export const flexSchema = baseSchema.extend({
  type: z.literal('flex'),
  vertical: z.boolean().optional().describe('flex 主轴的方向是否垂直，使用 flex-direction: column'),
  wrap: z.boolean().optional().describe('设置元素单行显示还是多行显示'),
  justify: z
    .enum(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly'])
    .optional()
    .describe('设置元素在主轴方向上的对齐方式'),
  align: z
    .enum(['flex-start', 'center', 'flex-end', 'baseline', 'stretch'])
    .optional()
    .describe('设置元素在交叉轴方向上的对齐方式'),
  gap: z.union([z.number(), z.string()]).optional().describe('设置网格之间的间隙'),
  body: z.any().array().optional().describe('子元素'),
  style: z.record(z.string(), z.any()).optional().describe('样式'),
})

export type FlexSchema = z.infer<typeof flexSchema>
